import { Arrow } from "@faire/web--source/slate/icons/foundation/Arrow";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";

import { useSelfServeContext } from "../../hooks/useSelfServeContext";
import { findPathsFromSelectedNode } from "../../utils/findPathsFromSelectedNode";

import {
  LinkedHelpCenterButtonWrapper,
  LinkedSingleHelpCenterButtonWrapper,
} from "./styles";
import { ILinkedHelpCenterButtonProps } from "./type";

export const LinkedHelpCenterButton: React.FC<ILinkedHelpCenterButtonProps> = ({
  searchableNode,
  onClick,
}) => {
  const { context } = useSelfServeContext();
  const { tree } = context;
  const nodePaths = findPathsFromSelectedNode(tree, searchableNode).filter(
    (node) => node.id !== "Root"
  );

  return (
    <LinkedHelpCenterButtonWrapper onClick={onClick}>
      {nodePaths.map((node, index) => (
        <React.Fragment key={node.id}>
          <LinkedSingleHelpCenterButtonWrapper>
            <Typography>{node.label}</Typography>
          </LinkedSingleHelpCenterButtonWrapper>
          <Spacer width="1x" />
          {index !== nodePaths.length - 1 ? (
            <>
              <Arrow direction="right" />
              <Spacer width="1x" />
            </>
          ) : null}
        </React.Fragment>
      ))}
    </LinkedHelpCenterButtonWrapper>
  );
};
